<div>
  <div class="flex flex-row justify-content-between flex-wrap align-items-center align-content-center py-3">
    <div class="flex flex-row">
      <div class="container-select">
        <label class="text-xs mb-1">
        {{ 'AdminUsersManagement.CreateEditUser.CountryLabel' | translate }}
      </label>
        <p-dropdown
          placeholder="{{
            'AdminUsersManagement.CreateEditUser.CountryLabel' | translate
          }} "
          [options]="countries"
          [(ngModel)]="selectedCountry"
          placeholder="Seleccione un país"
          (onChange)="filter()"
          optionLabel="name"
          optionValue="id"
          class="custom-dropdown"
          styleClass="w-12rem"
        />
      </div>
      <div class="container-select">
        <label class="text-xs mb-1">Tipo</label>
        <p-dropdown
          #stockSelect
          [options]="types"
          optionLabel="label"
          [(ngModel)]="selectedType"
          placeholder="Tipo"
          (onChange)="filter()"
          optionValue="value"
          class="custom-dropdown"
          styleClass="w-12rem"
        />
      </div>
    </div>
  </div>

      <div class="mt-4" *ngIf="selectedCountry && selectedType">
        <p-table
          [value]="consigneesNotifiers"
          [paginator]="true"
          [rows]="5"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          stateStorage="session"
          stateKey="statedemo-session"
          class="custom-table"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "AdminUsersManagement.CreateEditUser.IdLabel" | translate }}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.CompanyLabel" | translate}}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.VatIdLabel" | translate}}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.ContactNameLabel" | translate}}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.EmailLabel" | translate}}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.CityLabel" | translate}}</th>
              <th>{{"AdminUsersManagement.CreateEditUser.CountryLabel" | translate}}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-consigneeNotifier>
            <tr>
              <td>{{ consigneeNotifier.id }}</td>
              <td>{{ consigneeNotifier.companyName }}</td>
              <td>{{ consigneeNotifier.vat }}</td>
              <td>{{ consigneeNotifier.contactName }}</td>
              <td>{{ consigneeNotifier.contactEmail }}</td>
              <td>{{ consigneeNotifier.contactCity }}</td>
              <td>
                {{ consigneeNotifier.contactCountry | countryDescription }}
              </td>
              <td>
                <p-button
                  label="Asignar"
                  class="custom-text-button"
                  (onClick)="assignConsigneeNotifier(consigneeNotifier)"
                />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="p-fluid formgrid grid mt-4">
        <div class="field col-12 md:col-offset-10 md:col-2 mt-3">
          <p-button
            label="{{
              'AdminUsersManagement.Messages.CloseButton' | translate
            }}"
            (onClick)="close()"
            styleClass="p-button-outlined"
            class="custom-text-button"
          />
        </div>
      </div>

    <!--  -->

</div>
